/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 362ede66bfb5
 */

import * as z from "zod";

export type CreateFolderResponse = {
  success?: boolean | undefined;
  path?: string | undefined;
  name?: string | undefined;
};

export const CreateFolderResponse$zodSchema: z.ZodType<CreateFolderResponse> = z
  .object({
    name: z.string().optional().describe("The name of the created folder."),
    path: z.string().optional().describe("The path of the created folder."),
    success: z.boolean().optional().describe(
      "Whether the operation was successful.",
    ),
  });
